// extracted by mini-css-extract-plugin
export default {"root":"SearchInput_root__poxyY","box":"SearchInput_box__ITVh7","icon":"SearchInput_icon__4S3uc","input":"SearchInput_input__pvo3q"};